import _defineProperty from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { jsx as e } from "react/jsx-runtime";
import { Iframe as t } from "@phx-husky/iframe";
import n from "classnames";
import { useEffect as o } from "react";
!function (e, t) {
  void 0 === t && (t = {});
  var n = t.insertAt;

  if (e && "undefined" != typeof document) {
    var o = document.head || document.getElementsByTagName("head")[0],
        s = document.createElement("style");
    s.type = "text/css", "top" === n && o.firstChild ? o.insertBefore(s, o.firstChild) : o.appendChild(s), s.styleSheet ? s.styleSheet.cssText = e : s.appendChild(document.createTextNode(e));
  }
}(".global-contact-form {\n  width: 100%;\n  border: none;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImdsb2JhbC1jb250YWN0LWZvcm0uc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLFdBQVc7RUFDWCxZQUFZO0FBQ2QiLCJmaWxlIjoiZ2xvYmFsLWNvbnRhY3QtZm9ybS5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLmdsb2JhbC1jb250YWN0LWZvcm0ge1xuICB3aWR0aDogMTAwJTtcbiAgYm9yZGVyOiBub25lO1xufSJdfQ== */");

var s = function s(e) {
  var t;
  clearTimeout(t), t = setTimeout(function () {
    var t = document.getElementById(e);
    t && function (e) {
      e.contentWindow.postMessage("height", "*");
    }(t);
  }, 50);
},
    i = function i(e) {
  var t = document.getElementById(e);
  if (!t) return;

  var n = function () {
    var e = new URLSearchParams(window.location.search);
    return ["utm_source", "utm_medium"].reduce(function (t, n) {
      var o = e.get(n);
      return Object.assign(Object.assign({}, t), o && _defineProperty({}, n, o));
    }, {});
  }();

  t.contentWindow.postMessage({
    type: "utm",
    data: n
  }, "*");
},
    a = function a(_ref2) {
  var a = _ref2.src,
      c = _ref2.title,
      r = _ref2.id,
      m = _ref2.className,
      _ref2$onLoadCallbackD = _ref2.onLoadCallbackDelay,
      d = _ref2$onLoadCallbackD === void 0 ? 500 : _ref2$onLoadCallbackD;
  return o(function () {
    var e = function e(_e) {
      (function (e, t) {
        var n = document.getElementById(t);
        n && e.data.hasOwnProperty("height") && n.setAttribute("style", "height: ".concat(e.data.height, "px"));
      })(_e, r);
    },
        t = function t() {
      s(r);
    };

    return s(r), window.addEventListener("message", e), window.addEventListener("resize", t), function () {
      window.removeEventListener("message", e), window.removeEventListener("resize", t);
    };
  }, [r]), e(t, Object.assign({}, {
    src: a,
    title: c,
    id: r,
    className: n("global-contact-form", m),
    onLoad: function onLoad() {
      setTimeout(function () {
        i(r);
      }, d);
    }
  }));
};

export { a as GlobalContactForm };